<template>
  <form>
    <div class="gdpr-statement" v-if="isRegistration">
      <label>I agree <input type="checkbox" v-model="formData.agree" /></label>
      <hr />
    </div>

    <div :disabled="isRegistration && !formData.agree">
      <div class="form-group">
        <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Are you a student or qualified
          dentist?</label>
        <select v-model="formData.experience" :disabled="isRegistration && !formData.agree">
          <option value="">Please Select</option>
          <option value="Student">Student</option>
          <option value="Qualified Dentist">Qualified Dentist</option>
          <option value="Dentist with Special Interest">Dentist with Special Interest</option>
          <option value="Specialist">Specialist</option>
        </select>
      </div>

      <div class="form-group"
        v-if="formData.experience == 'Dentist with Special Interest' || formData.experience == 'Specialist'">
        <label>Are you happy to accept referrals?<input type="checkbox" v-model="formData.acceptReferrals" /></label>
        <label style="font-weight: bold; font-size: 10px;">This will allow other dentists to refer their cases to
          you.</label>
      </div>

      <div class="form-group" v-if="formData.acceptReferrals == true">
        <label>Specialty</label>
        <label style="font-weight: bold; font-size: 10px;">Choose the list of specialties that suite you.</label>
        <ul>
          <li v-for="specialty in specialties" :key="specialty">
            <label><input type="checkbox" :value="specialty" v-model="formData.selectedSpecialties" />{{ specialty
              }}</label>
          </li>
        </ul>
      </div>

      <div class="form-group" v-if="!isRegistration">
        <label>Email</label>
        <input type="text" v-model="formData.email" disabled="true" />
      </div>

      <div class="form-group" v-if="formData.acceptReferrals == true">
        <label>Name</label>
        <input type="text" v-model="formData.name" :disabled="isRegistration && !formData.agree" />
      </div>

      <div class="form-group" v-if="formData.acceptReferrals == true">
        <label>Postcode (separate by comma if more than one, for e.g. L4 3QP, L5 7TT)</label>
        <input type="text" v-model="formData.postcode" :disabled="isRegistration && !formData.agree" />
      </div>

      <div class="form-group" v-if="formData.experience == 'Student'">
        <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Undergraduate Year</label>
        <select v-model="formData.undergraduateYear" :disabled="isRegistration && !formData.agree">
          <option value="">Please Select</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
      </div>

      <div class="form-group"
        v-if="formData.experience == 'Qualified Dentist' || formData.experience == 'Dentist with Special Interest' || formData.experience == 'Specialist'">
        <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Year of BDS graduation (or
          equivalent)</label>
        <input type="number" v-model="formData.graduationYear" maxlength="4"
          :disabled="isRegistration && !formData.agree"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" />
      </div>

      <div class="form-group"
        v-if="formData.experience == 'Qualified Dentist' || formData.experience == 'Dentist with Special Interest' || formData.experience == 'Specialist'">
        <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Country of undergraduate
          qualification</label>
        <select v-model="formData.countryOfQualification" :disabled="isRegistration && !formData.agree">
          <option value="">Please Select</option>
          <option v-for="country of countries" v-bind:key="country.name" v-bind:value="country.name">{{ country.name }}
          </option>
        </select>
      </div>

      <div class="form-group"
        v-if="formData.experience == 'Qualified Dentist' || formData.experience == 'Dentist with Special Interest' || formData.experience == 'Specialist'">
        <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Main area of practice</label>
        <select v-model="formData.areaOfPractice" :disabled="isRegistration && !formData.agree">
          <option value="">Please Select</option>
          <option value="Private practice">Private practice</option>
          <option value="NHS general practice">NHS general practice</option>
          <option value="NHS community/salaried dental service">NHS community/salaried dental service</option>
          <option value="Hospital dental service">Hospital dental service</option>
        </select>
      </div>

      <div class="form-group"
        v-if="formData.experience == 'Qualified Dentist' || formData.experience == 'Dentist with Special Interest' || formData.experience == 'Specialist'">
        <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Have you had any postgraduate training
          in endodontics? </label>
        <select v-model="formData.havePostgraduateEndodontics" :disabled="isRegistration && !formData.agree">
          <option value="">Please Select</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>

      <div class="form-group" v-if="formData.havePostgraduateEndodontics == 'true'">
        <select v-model="formData.postgraduateEndodonticsExperience" :disabled="isRegistration && !formData.agree">
          <option value="">Please Select</option>
          <option value="Specialist">Specialist</option>
          <option value="Special interest in Endodontics">Special interest in Endodontics (e.g. MSc, Diploma)</option>
          <option value="Specialty Trainee (or equivalent)">Specialty Trainee (or equivalent)</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div class="form-group" v-if="formData.postgraduateEndodonticsExperience == 'Other'">
        <input type="text" v-model="formData.postgraduateEndodonticsExperienceOther" placeholder="Other..."
          :disabled="isRegistration && !formData.agree" />
      </div>

      <div v-if="formData.havePostgraduateEndodontics == 'true'">
        <div class="form-group"
          v-if="formData.postgraduateEndodonticsExperience == 'Specialty Trainee (or equivalent)'">
          <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Endodontics Year</label>
          <select v-model="formData.postgraduateEndodonticsYear" :disabled="isRegistration && !formData.agree">
            <option value="">Please Select</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
        <div v-else>
          <div class="form-group">
            <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">
              {{ formData.postgraduateEndodonticsExperience == 'Other' ? "Year of qualification" : "Year of graduation"
              }}
            </label>
            <input type="number" v-model="formData.postgraduateEndodonticsYear" maxlength="4"
              :disabled="isRegistration && !formData.agree"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" />
          </div>
        </div>
      </div>

      <!-- Only show account fields for registration -->
      <div v-if="isRegistration && !hasExistingUser">
        <hr />
        <h2 v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Account Details</h2>
        <div class="form-group">
          <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Email</label>
          <input type="email" v-model="formData.email" :disabled="isRegistration && !formData.agree" />
        </div>

        <div class="form-group">
          <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Password</label>
          <div class="password-group">
            <input v-bind:type="formData.visibility" v-model="formData.password"
              :disabled="isRegistration && !formData.agree" />
            <i v-if="formData.visibility == 'password'" class="far fa-eye-slash" v-on:click="togglePassword"></i>
            <i v-if="formData.visibility == 'text'" class="far fa-eye" v-on:click="togglePassword"></i>
          </div>
        </div>

        <div class="form-group">
          <label v-bind:class="{ 'disabled': isRegistration && !formData.agree }">Confirm Password</label>
          <div class="password-group">
            <input v-bind:type="formData.visibility" v-model="formData.confirmPassword"
              :disabled="isRegistration && !formData.agree" />
            <i v-if="formData.visibility == 'password'" class="far fa-eye-slash" v-on:click="togglePassword"></i>
            <i v-if="formData.visibility == 'text'" class="far fa-eye" v-on:click="togglePassword"></i>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showPasswordFields && !isRegistration">
      <hr />
      <h2>Change Password</h2>
      <div class="form-group">
        <label>Current Password</label>
        <input type="password" v-model="formData.oldPassword" />
      </div>

      <div class="form-group">
        <label>New Password</label>
        <div class="password-group">
          <input v-bind:type="formData.visibility" v-model="formData.newPassword" />
          <i v-if="formData.visibility == 'password'" class="far fa-eye-slash" v-on:click="togglePassword"></i>
          <i v-if="formData.visibility == 'text'" class="far fa-eye" v-on:click="togglePassword"></i>
        </div>
      </div>

      <div class="form-group">
        <label>Confirm New Password</label>
        <div class="password-group">
          <input v-bind:type="formData.visibility" v-model="formData.confirmPassword" />
          <i v-if="formData.visibility == 'password'" class="far fa-eye-slash" v-on:click="togglePassword"></i>
          <i v-if="formData.visibility == 'text'" class="far fa-eye" v-on:click="togglePassword"></i>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button class="btn" type="button" @click="submitForm">{{ submitButtonText }}</button>
      <button v-if="!isRegistration" class="btn btn-secondary" type="button" @click="$emit('cancel')">Cancel</button>
    </div>
  </form>
</template>

<script>
import postcodeService from '../services/postcode-service';

export default {
  name: 'UserProfileForm',

  props: {
    isRegistration: {
      type: Boolean,
      default: false
    },
    showPasswordFields: {
      type: Boolean,
      default: false
    },
    existingUser: {
      type: Object,
      default: null
    },
    submitButtonText: {
      type: String,
      default: 'Submit'
    }
  },

  data() {
    return {
      formData: {
        agree: false,
        acceptReferrals: false,
        name: "",
        postcode: "",
        selectedSpecialties: [],
        experience: "",
        undergraduateYear: "",
        graduationYear: "",
        countryOfQualification: "United Kingdom",
        areaOfPractice: "",
        havePostgraduateEndodontics: "",
        postgraduateEndodonticsExperience: "",
        postgraduateEndodonticsYear: "",
        postgraduateEndodonticsExperienceOther: "",
        email: "",
        password: "",
        confirmPassword: "",
        oldPassword: "",
        newPassword: "",
        visibility: 'password',
      },
      specialties: [
        "Endodontics",
        "Periodontics",
        "Prosthodontics",
        "Restorative"
      ],
      countries: [
        { name: 'Afghanistan', code: 'AF' },
        { name: 'Åland Islands', code: 'AX' },
        { name: 'Albania', code: 'AL' },
        { name: 'Algeria', code: 'DZ' },
        { name: 'American Samoa', code: 'AS' },
        { name: 'AndorrA', code: 'AD' },
        { name: 'Angola', code: 'AO' },
        { name: 'Anguilla', code: 'AI' },
        { name: 'Antarctica', code: 'AQ' },
        { name: 'Antigua and Barbuda', code: 'AG' },
        { name: 'Argentina', code: 'AR' },
        { name: 'Armenia', code: 'AM' },
        { name: 'Aruba', code: 'AW' },
        { name: 'Australia', code: 'AU' },
        { name: 'Austria', code: 'AT' },
        { name: 'Azerbaijan', code: 'AZ' },
        { name: 'Bahamas', code: 'BS' },
        { name: 'Bahrain', code: 'BH' },
        { name: 'Bangladesh', code: 'BD' },
        { name: 'Barbados', code: 'BB' },
        { name: 'Belarus', code: 'BY' },
        { name: 'Belgium', code: 'BE' },
        { name: 'Belize', code: 'BZ' },
        { name: 'Benin', code: 'BJ' },
        { name: 'Bermuda', code: 'BM' },
        { name: 'Bhutan', code: 'BT' },
        { name: 'Bolivia', code: 'BO' },
        { name: 'Bosnia and Herzegovina', code: 'BA' },
        { name: 'Botswana', code: 'BW' },
        { name: 'Bouvet Island', code: 'BV' },
        { name: 'Brazil', code: 'BR' },
        { name: 'British Indian Ocean Territory', code: 'IO' },
        { name: 'Brunei Darussalam', code: 'BN' },
        { name: 'Bulgaria', code: 'BG' },
        { name: 'Burkina Faso', code: 'BF' },
        { name: 'Burundi', code: 'BI' },
        { name: 'Cambodia', code: 'KH' },
        { name: 'Cameroon', code: 'CM' },
        { name: 'Canada', code: 'CA' },
        { name: 'Cape Verde', code: 'CV' },
        { name: 'Cayman Islands', code: 'KY' },
        { name: 'Central African Republic', code: 'CF' },
        { name: 'Chad', code: 'TD' },
        { name: 'Chile', code: 'CL' },
        { name: 'China', code: 'CN' },
        { name: 'Christmas Island', code: 'CX' },
        { name: 'Cocos (Keeling) Islands', code: 'CC' },
        { name: 'Colombia', code: 'CO' },
        { name: 'Comoros', code: 'KM' },
        { name: 'Congo', code: 'CG' },
        { name: 'Congo, The Democratic Republic of the', code: 'CD' },
        { name: 'Cook Islands', code: 'CK' },
        { name: 'Costa Rica', code: 'CR' },
        { name: 'Cote D\'Ivoire', code: 'CI' },
        { name: 'Croatia', code: 'HR' },
        { name: 'Cuba', code: 'CU' },
        { name: 'Cyprus', code: 'CY' },
        { name: 'Czech Republic', code: 'CZ' },
        { name: 'Denmark', code: 'DK' },
        { name: 'Djibouti', code: 'DJ' },
        { name: 'Dominica', code: 'DM' },
        { name: 'Dominican Republic', code: 'DO' },
        { name: 'Ecuador', code: 'EC' },
        { name: 'Egypt', code: 'EG' },
        { name: 'El Salvador', code: 'SV' },
        { name: 'Equatorial Guinea', code: 'GQ' },
        { name: 'Eritrea', code: 'ER' },
        { name: 'Estonia', code: 'EE' },
        { name: 'Ethiopia', code: 'ET' },
        { name: 'Falkland Islands (Malvinas)', code: 'FK' },
        { name: 'Faroe Islands', code: 'FO' },
        { name: 'Fiji', code: 'FJ' },
        { name: 'Finland', code: 'FI' },
        { name: 'France', code: 'FR' },
        { name: 'French Guiana', code: 'GF' },
        { name: 'French Polynesia', code: 'PF' },
        { name: 'French Southern Territories', code: 'TF' },
        { name: 'Gabon', code: 'GA' },
        { name: 'Gambia', code: 'GM' },
        { name: 'Georgia', code: 'GE' },
        { name: 'Germany', code: 'DE' },
        { name: 'Ghana', code: 'GH' },
        { name: 'Gibraltar', code: 'GI' },
        { name: 'Greece', code: 'GR' },
        { name: 'Greenland', code: 'GL' },
        { name: 'Grenada', code: 'GD' },
        { name: 'Guadeloupe', code: 'GP' },
        { name: 'Guam', code: 'GU' },
        { name: 'Guatemala', code: 'GT' },
        { name: 'Guernsey', code: 'GG' },
        { name: 'Guinea', code: 'GN' },
        { name: 'Guinea-Bissau', code: 'GW' },
        { name: 'Guyana', code: 'GY' },
        { name: 'Haiti', code: 'HT' },
        { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
        { name: 'Holy See (Vatican City State)', code: 'VA' },
        { name: 'Honduras', code: 'HN' },
        { name: 'Hong Kong', code: 'HK' },
        { name: 'Hungary', code: 'HU' },
        { name: 'Iceland', code: 'IS' },
        { name: 'India', code: 'IN' },
        { name: 'Indonesia', code: 'ID' },
        { name: 'Iran, Islamic Republic Of', code: 'IR' },
        { name: 'Iraq', code: 'IQ' },
        { name: 'Ireland', code: 'IE' },
        { name: 'Isle of Man', code: 'IM' },
        { name: 'Israel', code: 'IL' },
        { name: 'Italy', code: 'IT' },
        { name: 'Jamaica', code: 'JM' },
        { name: 'Japan', code: 'JP' },
        { name: 'Jersey', code: 'JE' },
        { name: 'Jordan', code: 'JO' },
        { name: 'Kazakhstan', code: 'KZ' },
        { name: 'Kenya', code: 'KE' },
        { name: 'Kiribati', code: 'KI' },
        { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
        { name: 'Korea, Republic of', code: 'KR' },
        { name: 'Kuwait', code: 'KW' },
        { name: 'Kyrgyzstan', code: 'KG' },
        { name: 'Lao People\'S Democratic Republic', code: 'LA' },
        { name: 'Latvia', code: 'LV' },
        { name: 'Lebanon', code: 'LB' },
        { name: 'Lesotho', code: 'LS' },
        { name: 'Liberia', code: 'LR' },
        { name: 'Libyan Arab Jamahiriya', code: 'LY' },
        { name: 'Liechtenstein', code: 'LI' },
        { name: 'Lithuania', code: 'LT' },
        { name: 'Luxembourg', code: 'LU' },
        { name: 'Macao', code: 'MO' },
        { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
        { name: 'Madagascar', code: 'MG' },
        { name: 'Malawi', code: 'MW' },
        { name: 'Malaysia', code: 'MY' },
        { name: 'Maldives', code: 'MV' },
        { name: 'Mali', code: 'ML' },
        { name: 'Malta', code: 'MT' },
        { name: 'Marshall Islands', code: 'MH' },
        { name: 'Martinique', code: 'MQ' },
        { name: 'Mauritania', code: 'MR' },
        { name: 'Mauritius', code: 'MU' },
        { name: 'Mayotte', code: 'YT' },
        { name: 'Mexico', code: 'MX' },
        { name: 'Micronesia, Federated States of', code: 'FM' },
        { name: 'Moldova, Republic of', code: 'MD' },
        { name: 'Monaco', code: 'MC' },
        { name: 'Mongolia', code: 'MN' },
        { name: 'Montserrat', code: 'MS' },
        { name: 'Morocco', code: 'MA' },
        { name: 'Mozambique', code: 'MZ' },
        { name: 'Myanmar', code: 'MM' },
        { name: 'Namibia', code: 'NA' },
        { name: 'Nauru', code: 'NR' },
        { name: 'Nepal', code: 'NP' },
        { name: 'Netherlands', code: 'NL' },
        { name: 'Netherlands Antilles', code: 'AN' },
        { name: 'New Caledonia', code: 'NC' },
        { name: 'New Zealand', code: 'NZ' },
        { name: 'Nicaragua', code: 'NI' },
        { name: 'Niger', code: 'NE' },
        { name: 'Nigeria', code: 'NG' },
        { name: 'Niue', code: 'NU' },
        { name: 'Norfolk Island', code: 'NF' },
        { name: 'Northern Mariana Islands', code: 'MP' },
        { name: 'Norway', code: 'NO' },
        { name: 'Oman', code: 'OM' },
        { name: 'Pakistan', code: 'PK' },
        { name: 'Palau', code: 'PW' },
        { name: 'Palestinian Territory, Occupied', code: 'PS' },
        { name: 'Panama', code: 'PA' },
        { name: 'Papua New Guinea', code: 'PG' },
        { name: 'Paraguay', code: 'PY' },
        { name: 'Peru', code: 'PE' },
        { name: 'Philippines', code: 'PH' },
        { name: 'Pitcairn', code: 'PN' },
        { name: 'Poland', code: 'PL' },
        { name: 'Portugal', code: 'PT' },
        { name: 'Puerto Rico', code: 'PR' },
        { name: 'Qatar', code: 'QA' },
        { name: 'Reunion', code: 'RE' },
        { name: 'Romania', code: 'RO' },
        { name: 'Russian Federation', code: 'RU' },
        { name: 'RWANDA', code: 'RW' },
        { name: 'Saint Helena', code: 'SH' },
        { name: 'Saint Kitts and Nevis', code: 'KN' },
        { name: 'Saint Lucia', code: 'LC' },
        { name: 'Saint Pierre and Miquelon', code: 'PM' },
        { name: 'Saint Vincent and the Grenadines', code: 'VC' },
        { name: 'Samoa', code: 'WS' },
        { name: 'San Marino', code: 'SM' },
        { name: 'Sao Tome and Principe', code: 'ST' },
        { name: 'Saudi Arabia', code: 'SA' },
        { name: 'Senegal', code: 'SN' },
        { name: 'Serbia and Montenegro', code: 'CS' },
        { name: 'Seychelles', code: 'SC' },
        { name: 'Sierra Leone', code: 'SL' },
        { name: 'Singapore', code: 'SG' },
        { name: 'Slovakia', code: 'SK' },
        { name: 'Slovenia', code: 'SI' },
        { name: 'Solomon Islands', code: 'SB' },
        { name: 'Somalia', code: 'SO' },
        { name: 'South Africa', code: 'ZA' },
        { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
        { name: 'Spain', code: 'ES' },
        { name: 'Sri Lanka', code: 'LK' },
        { name: 'Sudan', code: 'SD' },
        { name: 'Suriname', code: 'SR' },
        { name: 'Svalbard and Jan Mayen', code: 'SJ' },
        { name: 'Swaziland', code: 'SZ' },
        { name: 'Sweden', code: 'SE' },
        { name: 'Switzerland', code: 'CH' },
        { name: 'Syrian Arab Republic', code: 'SY' },
        { name: 'Taiwan, Province of China', code: 'TW' },
        { name: 'Tajikistan', code: 'TJ' },
        { name: 'Tanzania, United Republic of', code: 'TZ' },
        { name: 'Thailand', code: 'TH' },
        { name: 'Timor-Leste', code: 'TL' },
        { name: 'Togo', code: 'TG' },
        { name: 'Tokelau', code: 'TK' },
        { name: 'Tonga', code: 'TO' },
        { name: 'Trinidad and Tobago', code: 'TT' },
        { name: 'Tunisia', code: 'TN' },
        { name: 'Turkey', code: 'TR' },
        { name: 'Turkmenistan', code: 'TM' },
        { name: 'Turks and Caicos Islands', code: 'TC' },
        { name: 'Tuvalu', code: 'TV' },
        { name: 'Uganda', code: 'UG' },
        { name: 'Ukraine', code: 'UA' },
        { name: 'United Arab Emirates', code: 'AE' },
        { name: 'United Kingdom', code: 'GB' },
        { name: 'United States', code: 'US' },
        { name: 'United States Minor Outlying Islands', code: 'UM' },
        { name: 'Uruguay', code: 'UY' },
        { name: 'Uzbekistan', code: 'UZ' },
        { name: 'Vanuatu', code: 'VU' },
        { name: 'Venezuela', code: 'VE' },
        { name: 'Viet Nam', code: 'VN' },
        { name: 'Virgin Islands, British', code: 'VG' },
        { name: 'Virgin Islands, U.S.', code: 'VI' },
        { name: 'Wallis and Futuna', code: 'WF' },
        { name: 'Western Sahara', code: 'EH' },
        { name: 'Yemen', code: 'YE' },
        { name: 'Zambia', code: 'ZM' },
        { name: 'Zimbabwe', code: 'ZW' }
      ],
    }
  },

  computed: {
    hasExistingUser() {
      return this.existingUser !== null;
    }
  },

  watch: {
    existingUser: {
      immediate: true,
      handler(newUser) {
        if (newUser) {
          this.initializeFormWithUserData(newUser);
        }
      }
    }
  },

  methods: {
    initializeFormWithUserData(user) {
      this.formData.name = user.name || "";
      this.formData.postcode = user.postcode || "";
      this.formData.acceptReferrals = user.acceptReferrals || false;
      this.formData.selectedSpecialties = user.specialties?.map(s => s) || [];
      this.formData.experience = user.experience || "";
      this.formData.undergraduateYear = user.undergraduateYear || "";
      this.formData.graduationYear = user.graduationYear || "";
      this.formData.countryOfQualification = user.countryOfQualification || "United Kingdom";
      this.formData.areaOfPractice = user.areaOfPractice || "";
      this.formData.havePostgraduateEndodontics = user.havePostgraduateEndodontics ? "true" : "false";
      this.formData.postgraduateEndodonticsExperience = user.postgraduateEndodonticsExperience || "";
      this.formData.postgraduateEndodonticsYear = user.postgraduateEndodonticsYear || "";
      this.formData.email = user.email || "";
    },

    togglePassword() {
      this.formData.visibility = this.formData.visibility === 'password' ? 'text' : 'password';
    },

    async validateForm() {
      // Basic validation
      if (this.isRegistration && !this.formData.agree) {
        this.$emit('validation-error', "You must agree to the terms");
        return false;
      }

      if (this.formData.experience === "") {
        this.$emit('validation-error', "Select experience type");
        return false;
      }

      if (this.formData.experience === "Student" && this.formData.undergraduateYear === "") {
        this.$emit('validation-error', "Enter Undergraduate Year");
        return false;
      }

      if ((this.formData.experience === "Qualified Dentist" ||
        this.formData.experience === "Dentist with Special Interest" ||
        this.formData.experience === "Specialist") &&
        this.formData.graduationYear === "") {
        this.$emit('validation-error', "Enter Graduation Year");
        return false;
      }

      if ((this.formData.experience === "Qualified Dentist" ||
        this.formData.experience === "Dentist with Special Interest" ||
        this.formData.experience === "Specialist") &&
        this.formData.countryOfQualification === "") {
        this.$emit('validation-error', "Enter Country of Qualification");
        return false;
      }

      if ((this.formData.experience === "Qualified Dentist" ||
        this.formData.experience === "Dentist with Special Interest" ||
        this.formData.experience === "Specialist") &&
        this.formData.areaOfPractice === "") {
        this.$emit('validation-error', "Enter Main Area of Practice");
        return false;
      }

      if ((this.formData.experience === "Qualified Dentist" ||
        this.formData.experience === "Dentist with Special Interest" ||
        this.formData.experience === "Specialist") &&
        this.formData.havePostgraduateEndodontics === "") {
        this.$emit('validation-error', "Select Postgraduate Training in Endodontics");
        return false;
      }

      if (this.formData.havePostgraduateEndodontics === "true" &&
        this.formData.postgraduateEndodonticsExperience === "") {
        this.$emit('validation-error', "Specify postgraduate training in endodontics");
        return false;
      }

      if (this.formData.postgraduateEndodonticsExperience === "Other" &&
        this.formData.postgraduateEndodonticsExperienceOther === "") {
        this.$emit('validation-error', "Specify postgraduate training in endodontics");
        return false;
      }

      if (this.formData.havePostgraduateEndodontics === "true" &&
        this.formData.postgraduateEndodonticsYear === "") {
        this.$emit('validation-error', "Specify year");
        return false;
      }

      if (this.isRegistration && this.formData.email === "") {
        this.$emit('validation-error', "Enter email address");
        return false;
      }

      if (this.isRegistration && (this.formData.password === "" || this.formData.confirmPassword === "")) {
        this.$emit('validation-error', "Enter password");
        return false;
      }

      if (this.isRegistration && this.formData.password !== this.formData.confirmPassword) {
        this.$emit('validation-error', "Passwords do not match");
        return false;
      }

      if (this.showPasswordFields && !this.isRegistration) {
        if (this.formData.oldPassword === "") {
          this.$emit('validation-error', "Enter current password");
          return false;
        }

        if (this.formData.newPassword === "") {
          this.$emit('validation-error', "Enter new password");
          return false;
        }

        if (this.formData.newPassword !== this.formData.confirmPassword) {
          this.$emit('validation-error', "New passwords do not match");
          return false;
        }
      }

      if (this.formData.acceptReferrals && this.formData.selectedSpecialties.length === 0) {
        this.$emit('validation-error', "Please select at least one specialty");
        return false;
      }

      if (this.formData.acceptReferrals && this.formData.name === "") {
        this.$emit('validation-error', "Enter name");
        return false;
      }

      if (this.formData.acceptReferrals && this.formData.postcode === "") {
        this.$emit('validation-error', "Enter postcode");
        return false;
      }

      if (this.formData.postcode !== "") {
        try {
          const result = await postcodeService.validatePostcode(this.formData.postcode);
          if (!result.isValid) {
            this.$emit('validation-error', "Enter valid postcode");
            return false;
          }
        } catch (error) {
          this.$emit('validation-error', "Failed to validate postcode");
          return false;
        }
      }

      return true;
    },

    async submitForm() {
      const isValid = await this.validateForm();

      if (isValid) {
        // Create the DTO based on form data
        const dto = {
          name: this.formData.name,
          postcode: this.formData.postcode,
          acceptReferrals: this.formData.acceptReferrals,
          specialties: this.formData.selectedSpecialties,
          email: this.formData.email,
          password: this.formData.password,
          experience: this.formData.experience,
          undergraduateYear: this.formData.undergraduateYear === "" ? null : this.formData.undergraduateYear,
          graduationYear: this.formData.graduationYear === "" ? null : this.formData.graduationYear,
          countryOfQualification: this.formData.countryOfQualification,
          areaOfPractice: this.formData.areaOfPractice,
          havePostgraduateEndodontics: this.formData.havePostgraduateEndodontics === "" ? null : this.formData.havePostgraduateEndodontics === 'true',
          postgraduateEndodonticsExperience: this.formData.postgraduateEndodonticsExperience === "" ? null : this.formData.postgraduateEndodonticsExperience,
          postgraduateEndodonticsYear: this.formData.postgraduateEndodonticsYear === "" ? null : this.formData.postgraduateEndodonticsYear,
        };

        // Add password change details if applicable
        if (this.showPasswordFields && !this.isRegistration) {
          dto.oldPassword = this.formData.oldPassword;
          dto.newPassword = this.formData.newPassword;
        }

        this.$emit('submit', dto);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  label {
    font-weight: bold;
    text-align: left;
    margin-bottom: 5px;

    &.disabled {
      color: lightgray;
    }
  }

  input,
  select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  ul {
    list-style-type: none;
    padding-left: 0;

    li {
      margin-bottom: 5px;
    }
  }
}

.password-group {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-right: 8px;

  input {
    flex: 1;
    border: none;
    padding: 8px;

    &:focus {
      outline: none;
    }
  }

  i {
    cursor: pointer;
    color: #666;
  }
}

hr {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #eee;
}

h2 {
  font-size: 18px;
  margin-bottom: 15px;

  &.disabled {
    color: lightgray;
  }
}

.form-actions {
  margin-top: 20px;
  display: flex;
  gap: 10px;

  .btn {
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;

    &.btn-secondary {
      background-color: #f1f1f1;
      color: #333;
    }
  }
}
</style>